import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedReembolsoComponent {
  desplegar = false
  onAceptar

  getAccion (accion) {
    this.desplegar = false
    if (accion) {
      this.onAceptar()
    }
  }
}

module.component('viaticosSharedReembolso', {
  controller: ViaticosSharedReembolsoComponent,
  template,
  bindings: {
    onAceptar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/reembolso/component.js